var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"content":_vm.CONSTANTS.TEXT,"css":_vm.CONSTANTS.CSS}})}
var staticRenderFns = []

export { render, staticRenderFns }